/**
 * Generic data table wrapper for admin/list views.
 * Composable building block for derivative app pages.
 */
import type { ReactNode } from 'react'

import { cn } from '../../lib/utils'

export type DataTableProps = {
  children: ReactNode
  className?: string
}

export function DataTable({ children, className }: DataTableProps) {
  return (
    <div className={cn('rounded-lg border border-foreground/10 overflow-hidden', className)}>
      <table className="w-full text-sm">
        {children}
      </table>
    </div>
  )
}

export function DataTableHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <thead className={cn('korvo-bg-background-muted', className)}>{children}</thead>
}

export function DataTableBody({ children, className }: { children: ReactNode; className?: string }) {
  return <tbody className={className}>{children}</tbody>
}

export function DataTableRow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <tr className={cn('border-b border-foreground/10 last:border-0', className)}>
      {children}
    </tr>
  )
}
